<template>
   <div>
     <TextBlockWithHeader
     title="Приказ Минцифры №511"
     theme="dark"
     text="Сведения в соответствии с требованиями Приказа Минцифры России от 02.06.2025 N 511 «ДОПОЛНИТЕЛЬНЫЕ ТРЕБОВАНИЯ, ПРЕДЪЯВЛЯЕМЫЕ К ОФИЦИАЛЬНОМУ САЙТУ РОССИЙСКОЙ ОРГАНИЗАЦИИ, ОСУЩЕСТВЛЯЮЩЕЙ ДЕЯТЕЛЬНОСТЬ В ОБЛАСТИ ИНФОРМАЦИОННЫХ ТЕХНОЛОГИЙ, В ИНФОРМАЦИОННО-ТЕЛЕКОММУНИКАЦИОННОЙ СЕТИ ИНТЕРНЕТ
     </br></br>
         Полное наименование организации: Общество с ограниченной ответственностью «Поисковый портал «Спутник»
    </br></br>
 Сокращенное наименование: ООО «ПП «Спутник» 
    </br></br>
 Юридический адрес: 108811 г. Москва, п. Московский, 22-й километр Киевского шоссе, домовладение 6, стр. 1
    </br></br>
 Фактический почтовый адрес: 108811 г. Москва, п. Московский, 22-й километр Киевского шоссе, домовладение 6, стр. 1
    </br></br>
 ИНН / КПП: 7704304738 / 775101001
    </br></br>
 Основной код ОКВЭД: 62.01
    </br></br>
 Адрес электронной почты: info@sputnik.ru
    </br></br>
 Номер телефона: +7 (495) 855-64-80
      </br></br>    
Коды видов деятельности в области информационных технологий, осуществляемых организацией, в соответствии с перечнем видов деятельности в области информационных технологий, утвержденным приказом Министерства цифрового развития, связи и массовых коммуникаций Российской Федерации от 11 мая 2023 г. N 449 (зарегистрирован Министерством юстиции Российской Федерации 14 августа 2023 г., регистрационный N 74778): 1.01, 2.01, 8.01.
      </br></br>
Информация, содержащая описание реализуемых (разрабатываемых) организацией продуктов, выполняемых работ, оказываемых услуг: ИТ-компания ООО «ПП «Спутник» разрабатывает, внедряет и сопровождает информационные решения (раздел сайта «Проекты): Корпоративный поиск «Спутник», Аналитическая система «Спутник».  А также разрабатывает программные продукты в следующих сферах: поиск устройств IoT, поиск уязвимостей Web и IoT, обезличивание и маскирование персональных данных, генерация синтетических тестовых данных. 
      </br></br>
Стоимость проектов и решений определяется по запросу в зависимости от требуемых характеристик. Запрос направлять по адресу: sales@sputnik.ru
      </br></br>
 В рамках осуществления деятельности в области информационных технологий специалисты компании используют следующие языки программирования: Go, JavaScript, Postgres, Redis.
      </br></br>
 ООО «ПП «Спутник» является правообладателем зарегистрированного в Едином реестр российских программ для ЭВМ и БД программных продуктов:
      </br></br>
 Корпоративный поиск «Спутник» (реестровая запись №3492 от 03.05.2017)  
      </br></br>
 Аналитическая система «Спутник» (реестровая запись №1933 от 23.09.2016)"
     />
   </div>
 </template>
 
 <script>
 import { TextBlockWithHeader } from 'sputnik-ui/src/index';
 
 export default {
   name: 'Prikaz511Page',
   components: { TextBlockWithHeader },
 };
 </script>
 
 <style lang="scss">
   .cover-wrapper .cover {
     background-color: initial;
   }
 </style>
 